import { ILoadedMaterial } from './../../shared/interfaces/material/loaded-material';
import { Pipe, PipeTransform } from '@angular/core';
import { IMultiPrintDevice } from '@multiprint/abstract/multi-print-device';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'multiPrintMaterials'
})
export class MultiPrintMaterialsPipe implements PipeTransform {
  constructor(private translate: TranslateService) { }

  transform(value: IMultiPrintDevice[]): ILoadedMaterial[] {
    var merged = [].concat.apply([], value.map(p => p.materials) as []) as ILoadedMaterial[];
    var res = [...new Map(merged.map(item => [item.id, item])).values()].sort((a, b) => a.name.localeCompare(b.name));
    res.unshift({
      id: -9,
      name: this.translate.instant("common.all-materials").toUpperCase(),
      unit: 'g'
    })
    return res;
  }

}
